import { Button, Col, Form as BForm, Row, Container } from "react-bootstrap";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import CBFileUploader from "./CBFileUploader";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "react-redux-loading-bar";
import { toast } from "react-toastify";
import axios from '../../../apis/Api';

const initialValues = {
    excelFile: null,
};

const validationSchema = Yup.object().shape({
    excelFile: Yup.mixed()
        .required("Excel file is required.")
        .test(
            "fileType",
            "Invalid file type. Only Excel files are allowed.",
            (value) =>
                value &&
                ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"].includes(value.type)
        )
        .test(
            "fileSize",
            "File size must be less than 5MB.",
            (value) => value && value.size <= 100 * 1024 * 1024
        ),
});

const CBDataSharingForm = () => {
    const dispatch = useDispatch();

    const UploadFile = async (file, noOfFiles = 1) => {
        dispatch(showLoading());

        try {
            const { data } = await axios.get(`api/LenderKYC/GetCreditBookPresignedUrl/${noOfFiles}`);
            if (!data.isSuccess) {
                throw new Error("pre-signed URL not found");
            }
            const response = await fetch(data?.response, {
                method: 'PUT',
                headers: {
                    "Content-Type": file.type
                },
                body: file
            });

            if (!response.ok) {
                throw new Error("Upload to pre-signed URL failed");
            }

            toast.success("File shared successfully");
        } catch (error) {
            console.error(error);
            toast.error("Failed to share the file.");
        } finally {
            dispatch(hideLoading());
        }
    };

    const handleSubmit = async (values, { resetForm }) => {
        try {
            await UploadFile(values.excelFile);
            resetForm();
        } catch (error) {
            console.error("Shared failed:", error);
        }
    };

    return (
        <div>
            <VzPageContainer title="CB Data Sharing">
                <Row className="mb-3">
                    <Col>
                        <h4 className="fw-bold">Credit Book Data Sharing</h4>
                    </Col>
                </Row>
                <Container fluid className="mt-5 d-flex align-items-center justify-content-center">
                    <Col xs={12} sm={10} md={6} lg={5}>
                        <div className="text-center mb-4">
                            <p className="text-muted">Please upload your Excel file to share data with Credit Book.</p>
                        </div>

                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue, errors, touched, isValid, isSubmitting }) => (
                                <Form autoComplete="off">
                                    <BForm.Group controlId="excelFile">
                                        <BForm.Label className="fw-semibold">Upload Excel File</BForm.Label>
                                        <CBFileUploader
                                            fieldName="excelFile"
                                            value={values.excelFile}
                                            setFieldValue={setFieldValue}
                                            label=""
                                            removeFileDiabled={isSubmitting}
                                            className="form-control"
                                        />
                                        {errors.excelFile && touched.excelFile && (
                                            <div className="text-danger mt-2">{errors.excelFile}</div>
                                        )}
                                    </BForm.Group>

                                    <div className="d-grid mt-4">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            disabled={isSubmitting || !values.excelFile || !isValid}
                                        >
                                            {isSubmitting ? "sharing..." : "Share Data"}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </Col>
                </Container>
            </VzPageContainer>
        </div>
    );
};

export default CBDataSharingForm;
